<template>
    <div class="error">
        <van-empty
            image="error"
            description="加载失败，请刷新重试"
        />
        <van-button
            class="reload-button"
            color="#ff5d7d"
            round
            block
            @click="handleReload"
        >刷新</van-button>

        <slot name="footer" />
    </div>
</template>

<script setup>

function handleReload() {
    window.location.reload()
}
</script>

<style lang="less" scoped>
.error {
    width:100vw;
    height: 100vh;
    padding: 20px;
    .reload-button {
        margin: 20px 0 8px 0;
    }
}
</style>